<script setup lang="ts">
defineProps<{
    label: string
    content: any
    colorMode: 'light' | 'dark'
}>()

const emit = defineEmits<{
    (e: 'on-close'): void
}>()
</script>

<template>
    <div>
        <header
            :class="[
                `py-3.5 pl-20 pr-6 border-b border-chsc-indigo-500 flex items-center justify-between`,
                { 'bg-chsc-indigo-500 text-white': colorMode === 'dark' },
                { 'bg-chsc-yellow text-chsc-indigo-500': colorMode === 'light' },
            ]"
        >
            <h3 class="fs-3xl font-eb-garamond font-medium">
                {{ label }}
            </h3>
            <button
                class="flex items-center justify-center fs-xl cursor-pointer"
                @click="emit('on-close')"
            >
                <UIcon name="i-heroicons-x-mark" />
            </button>
        </header>
        <div class="p-20 max-h-[75vh] overflow-y-auto global-text">
            <StoryblokRichText :doc="content" />
        </div>
    </div>
</template>
